import { ofType, combineEpics } from "redux-observable";
import {
  switchMap, map, tap, catchError,
} from "rxjs/operators";
import { throwError, empty } from "rxjs";

import { errorHandler, httpGet } from "../../../../common/httpCall";

import {
  optionsScoreGetSuccess,
  OPTIONS_SCORE_GET_ATTEMPT,
} from "./patientOrgStepThree.action";

export const epicGetOptionsScores = (action$, state$) => action$.pipe(
  ofType(OPTIONS_SCORE_GET_ATTEMPT),
  switchMap(({ payload }) => httpGet({
    call: "gsk/option_scores",
  }).pipe(
    map((result) => optionsScoreGetSuccess(result.response)),
    catchError((err) => errorHandler(err, payload.enqueueSnackbar)),
  )),
);

const patientOrgStepThreeEpic = combineEpics(epicGetOptionsScores);

export default patientOrgStepThreeEpic;
